// @flow
import type {
  Get,
} from 'fc-fetch/types'

import type {
  Action,
} from 'fc-flow-types/redux'

import type {
  Token,
} from '../../types'

// Effect Managers
import { call, put } from 'redux-saga/effects'

// Sagas
import { getToken } from 'fc-auth'

// Action Creators
import {
  receiveToken,
  removeCredentials,
} from '../actions'

// Exports
/**
 * validateToken - Makes a server call to check if the the token that is in use is valid.
 *
 * @returns {string}  Returns the token if it was valid, otherwise null
 */
export default function *validateToken (
  { __get, token: maybeToken }: { __get: Get, token: ?Token }
  //
): Generator<*, ?Token, *> {
  // Grab the token off state or local storage.
  const token: ?string = yield maybeToken || call(getToken)

  if (token) {
    // Dispatch a GET request to determine the token's validity
    try {
      const response: Response = yield call(__get, {path: 'token/'})
      const status: number = response.status

      // If the server response is ok
      if (status >= 200 && status < 300) {
        const [ data ] = yield call([response, response.json])
        const { username } = data.fields

        const action: Action<{user: string, token: string}> = receiveToken({user: username, token})
        yield put(action)

        return token
      }
    } catch (error) {
      console.error(error)
    }
  }
  // The token was not valid, remove credentials from state and local storage
  yield put(removeCredentials())

  // // Return null if there was not token or if it was invalid
  return null
}
